import { translate } from '../../helpers/translate.helper';
import { InfoPopover } from '../../InfoPopover/InfoPopover';
import { Box } from '../../ui/Box';

interface PriceHeadingProps {
    align?: 'left' | 'right';
}

export const PriceHeading = (props: PriceHeadingProps) => {
    const { align = 'left' } = props;
    const justifyContent = align === 'right' ? 'flex-end' : 'flex-start';

    return (
        <Box display="flex" alignItems="center" gap={4} justifyContent={justifyContent}>
            {translate('order.price')}
            <InfoPopover>{translate('order.pricePopover')}</InfoPopover>
        </Box>
    );
};
